import { FC, ReactNode, useEffect } from 'react';
import useApp from '../../hooks/use-app.hook';
import { Box } from '@mui/material';
import { UseQueryResult } from 'react-query';
import Loader from '../loader';
import { createUseStyles } from 'react-jss';
import { getBreakpoint } from '@/theme';
import classNames from 'classnames';

export interface PageProps {
  children?: ReactNode;
  title?: string;
  query?: UseQueryResult;
  className?: string;
}

const useStyles = createUseStyles({
  page: {
    height: 'calc(100% - 50px)', // the 50px matches styles.header in @src/components/App.tsx
    width: '100%',
  },
  [getBreakpoint('md')]: {
    page: {
      height: 'calc(100% - 46px)',
    },
  },
});

const Page: FC<PageProps> = ({ children, title = '', query, className }) => {
  const { setPageTitle } = useApp();
  const styles = useStyles();
  useEffect(() => {
    setPageTitle(title);
  }, [setPageTitle, title]);

  const { isLoading = false } = query || {};
  const compClass = classNames(styles.page, className);

  return (
    <Box className={compClass}>
      {isLoading && (
        <Box height="100%" width="100%" display="flex" alignItems="flex-end">
          <Loader />
        </Box>
      )}
      {!isLoading && (
        <Box minHeight="100%" width="100%" className="page-inner">
          {children}
        </Box>
      )}
    </Box>
  );
};

export default Page;
